import CheckOutlined from '@mui/icons-material/CheckOutlined'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import * as React from 'react'

import { cn } from '@/shared/lib/utils'

type CheckboxProps = React.ComponentPropsWithoutRef<
  typeof CheckboxPrimitive.Root
> & {
  variant?: 'default' | 'dark'
}

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  CheckboxProps
>(({ className, variant = 'default', ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'peer h-4 w-4 shrink-0 rounded-sm border focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
      variant === 'default' && [
        'border-primary',
        'focus-visible:outline-primary',
        'data-[state=checked]:bg-primary',
        'data-[state=checked]:text-primary',
      ],
      variant === 'dark' && [
        'border-white',
        'focus-visible:outline-white',
        'data-[state=checked]:bg-white',
        'data-[state=checked]:text-black',
      ],
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn('flex items-center justify-center text-current')}
    >
      <CheckOutlined sx={{ fontSize: 16 }} />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
